function addAllItems(variantIdArray, clickedButton, plantHandle) {
  var newVariantIdArray = variantIdArray.split(',');

  // Get the cart notification element
  const cartNotification = document.querySelector('cart-notification');
  if (!cartNotification) {
    console.error('Cart notification element not found');
    return;
  }

  // Get the plant height from the hidden input (for the plant, not the pot)
  const plantHeightInput = document.getElementById('plant-height');
  const plantHeight = plantHeightInput ? plantHeightInput.value : null;

  var product_data = newVariantIdArray.map((variantId, index) => {
    // Index 0 = pot, index 1 = plant
    if (index === 0 && plantHandle) {
      // Tag pot with which plant it was chosen for (underscore prefix hides from customer)
      return {
        quantity: 1,
        id: variantId,
        properties: {
          '_paired_plant': plantHandle
        }
      };
    }
    if (plantHeight && index === 1) {
      return {
        quantity: 1,
        id: variantId,
        properties: {
          'Plant Height': plantHeight
        }
      };
    }
    return {quantity: 1, id: variantId};
  })
  
  // Create FormData to match the main add to cart behavior
  const formData = new FormData();
  
  // Add items as form data with properties
  product_data.forEach((item, index) => {
    formData.append(`items[${index}][id]`, item.id);
    formData.append(`items[${index}][quantity]`, item.quantity);
    
    // Add properties if they exist
    if (item.properties) {
      Object.keys(item.properties).forEach(key => {
        formData.append(`items[${index}][properties][${key}]`, item.properties[key]);
      });
    }
  });
  
  // Add sections to get updated cart data for the popup
  const sectionsToRender = cartNotification.getSectionsToRender().map((section) => section.id);
  sectionsToRender.forEach(section => {
    formData.append('sections[]', section);
  });
  formData.append('sections_url', window.location.pathname);
  
  // Add loading state to button
  if (clickedButton) {
    clickedButton.setAttribute('aria-disabled', true);
    clickedButton.classList.add('loading');
  }
        
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      // Handle error
      alert(response.description);
      return;
    }
    
    // Store the variant IDs that were just added so the notification can display them
    window.recentlyAddedItems = newVariantIdArray;
    
    // Show the cart notification popup (same as main add to cart button)
    cartNotification.renderContents(response);
  })
  .catch((e) => {
    console.error('Error:', e);
    alert('There was an error adding items to cart. Please try again.');
  })
  .finally(() => {
    // Remove loading state
    if (clickedButton) {
      clickedButton.classList.remove('loading');
      clickedButton.removeAttribute('aria-disabled');
    }
  });
}

// Pot slider buttons are rendered server-side and rebuilt client-side on variant
// change, so a single delegated listener handles both without inline handlers.
document.addEventListener('click', function (event) {
  const button = event.target.closest('.pot-button[data-pot-variant]');
  if (!button || button.classList.contains('loading')) return;
  event.preventDefault();

  // Prefer the live product form's variant id so a tap that lands between a
  // size change and the deferred slider rebuild still pairs the right plant.
  let plantVariant = button.dataset.plantVariant;
  const section = button.closest('.dpots-section');
  const sectionId = section && section.id.startsWith('dpots-') ? section.id.slice(6) : null;
  const form = sectionId ? document.getElementById('product-form-' + sectionId) : null;
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  if (idInput && idInput.value) plantVariant = idInput.value;

  addAllItems(button.dataset.potVariant + ',' + plantVariant, button, button.dataset.plantHandle);
});
